export default "__VITE_ASSET__BnoOVJy1__"